var _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _tspan10, _tspan11, _tspan12, _tspan13, _tspan14, _tspan15, _tspan16, _tspan17, _tspan18, _tspan19, _tspan20, _tspan21, _tspan22, _tspan23, _tspan24, _tspan25, _tspan26, _tspan27, _tspan28, _tspan29, _tspan30, _tspan31, _tspan32, _tspan33, _tspan34, _tspan35, _tspan36, _tspan37, _tspan38, _tspan39, _tspan40, _tspan41, _tspan42, _tspan43, _tspan44, _tspan45, _tspan46, _tspan47, _tspan48, _tspan49, _tspan50, _tspan51, _tspan52, _tspan53, _tspan54, _tspan55, _tspan56, _tspan57, _tspan58, _tspan59, _tspan60, _tspan61, _tspan62, _tspan63, _tspan64, _tspan65, _tspan66, _tspan67, _tspan68, _tspan69, _tspan70, _tspan71, _tspan72, _tspan73, _tspan74, _tspan75, _tspan76, _tspan77, _tspan78, _tspan79, _tspan80, _tspan81, _tspan82, _tspan83, _tspan84, _tspan85, _tspan86, _tspan87, _tspan88, _tspan89, _tspan90, _tspan91, _tspan92, _tspan93, _tspan94, _tspan95, _tspan96, _tspan97, _tspan98, _tspan99, _tspan100, _tspan101, _tspan102, _tspan103, _tspan104, _tspan105, _tspan106, _tspan107, _tspan108, _tspan109, _tspan110, _tspan111, _tspan112, _tspan113, _tspan114, _tspan115, _tspan116, _tspan117, _tspan118, _tspan119, _tspan120, _tspan121, _tspan122, _tspan123, _tspan124, _tspan125, _tspan126, _tspan127, _tspan128, _tspan129, _tspan130, _tspan131, _tspan132, _tspan133, _tspan134, _tspan135, _tspan136, _tspan137, _tspan138, _tspan139, _tspan140, _tspan141, _tspan142, _tspan143, _tspan144, _tspan145, _tspan146, _tspan147, _tspan148, _tspan149, _tspan150, _tspan151, _tspan152, _tspan153, _tspan154, _tspan155, _tspan156, _tspan157, _tspan158, _tspan159, _tspan160, _tspan161, _tspan162, _tspan163, _tspan164, _tspan165, _tspan166, _tspan167, _tspan168, _tspan169, _tspan170, _tspan171, _tspan172, _tspan173, _tspan174, _tspan175, _tspan176, _tspan177, _tspan178, _tspan179, _tspan180, _tspan181, _tspan182, _tspan183, _tspan184, _tspan185, _tspan186, _tspan187, _tspan188, _tspan189, _tspan190, _tspan191, _tspan192, _tspan193;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommandesDirect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "55cm",
    height: "59cm",
    viewBox: "1238 358 1084 1164",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1760,
    y: 500,
    width: 80,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1760,
    y: 500,
    width: 80,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1760,
    y: 540,
    width: 80,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1760,
    y: 540,
    width: 80,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1760,
    y: 600,
    width: 80,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1760,
    y: 600,
    width: 80,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1760,
    y: 640,
    width: 80,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1760,
    y: 640,
    width: 80,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1760,
    y: 960,
    width: 80,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1760,
    y: 960,
    width: 80,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1760,
    y: 680,
    width: 80,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1760,
    y: 680,
    width: 80,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1760,
    y: 760,
    width: 80,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1760,
    y: 760,
    width: 80,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1760,
    y: 840,
    width: 80,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1760,
    y: 840,
    width: 80,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1760,
    y: 880,
    width: 80,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1760,
    y: 880,
    width: 80,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1760,
    y: 1040,
    width: 80,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1760,
    y: 1040,
    width: 80,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1760,
    y: 1100,
    width: 80,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1760,
    y: 1100,
    width: 80,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1760,
    y: 1280,
    width: 80,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1760,
    y: 1280,
    width: 80,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1760,
    y: 1320,
    width: 80,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1760,
    y: 1320,
    width: 80,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1760,
    y: 1160,
    width: 80,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1760,
    y: 1160,
    width: 80,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1760,
    y: 1220,
    width: 80,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1760,
    y: 1220,
    width: 80,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1760,
    y: 1400,
    width: 80,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1760,
    y: 1400,
    width: 80,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1760,
    y: 1440,
    width: 80,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1760,
    y: 1440,
    width: 80,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1760,
    y: 1480,
    width: 80,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1760,
    y: 1480,
    width: 80,
    height: 40
  })), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1800,
    y: 629.775
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 1800,
    y: 629.775
  }, "KRF"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1800,
    y: 669.775
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 1800,
    y: 669.775
  }, "KRG"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1800,
    y: 869.775
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 1800,
    y: 869.775
  }, "KRC"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1800,
    y: 909.775
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 1800,
    y: 909.775
  }, "KRL"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1800,
    y: 709.775
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 1800,
    y: 709.775
  }, "KRV"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1800,
    y: 1069.78
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 1800,
    y: 1069.78
  }, "EXP"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1800,
    y: 1129.78
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 1800,
    y: 1129.78
  }, "CMP"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1800,
    y: 989.775
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 1800,
    y: 989.775
  }, "KRE"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1800,
    y: 789.775
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 1800,
    y: 789.775
  }, "OCT"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1800,
    y: 1429.78
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 1800,
    y: 1429.78
  }, "MVB"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1800,
    y: 1469.78
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 1800,
    y: 1469.78
  }, "MVD"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1800,
    y: 1509.78
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 1800,
    y: 1509.78
  }, "MVT"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1800,
    y: 529.775
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 1800,
    y: 529.775
  }, "CLF"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1800,
    y: 569.775
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 1800,
    y: 569.775
  }, "CLG"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1800,
    y: 1309.78
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    x: 1800,
    y: 1309.78
  }, "VSM"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1800,
    y: 1349.78
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    x: 1800,
    y: 1349.78
  }, "VRM"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1800,
    y: 1249.78
  }, _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    x: 1800,
    y: 1249.78
  }, "INY"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1800,
    y: 1189.78
  }, _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    x: 1800,
    y: 1189.78
  }, "NOP"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1240,
    y: 500,
    width: 420,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1240,
    y: 500,
    width: 420,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1240,
    y: 540,
    width: 420,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1240,
    y: 540,
    width: 420,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1240,
    y: 600,
    width: 420,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1240,
    y: 600,
    width: 420,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1240,
    y: 640,
    width: 420,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1240,
    y: 640,
    width: 420,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1240,
    y: 680,
    width: 420,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1240,
    y: 680,
    width: 420,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1240,
    y: 840,
    width: 420,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1240,
    y: 840,
    width: 420,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1240,
    y: 880,
    width: 420,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1240,
    y: 880,
    width: 420,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1240,
    y: 760,
    width: 420,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1240,
    y: 760,
    width: 420,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1240,
    y: 1220,
    width: 420,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1240,
    y: 1220,
    width: 420,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1240,
    y: 960,
    width: 420,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1240,
    y: 960,
    width: 420,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1240,
    y: 1040,
    width: 420,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1240,
    y: 1040,
    width: 420,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1240,
    y: 1100,
    width: 420,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1240,
    y: 1100,
    width: 420,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1240,
    y: 1280,
    width: 420,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1240,
    y: 1280,
    width: 420,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1240,
    y: 1320,
    width: 420,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1240,
    y: 1320,
    width: 420,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1240,
    y: 1400,
    width: 420,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1240,
    y: 1400,
    width: 420,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1240,
    y: 1440,
    width: 420,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1240,
    y: 1440,
    width: 420,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1240,
    y: 1480,
    width: 420,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1240,
    y: 1480,
    width: 420,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1240,
    y: 1160,
    width: 420,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1240,
    y: 1160,
    width: 420,
    height: 40
  })), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1280,
    y: 629.775
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    x: 1280,
    y: 629.775
  }, "40 caract\xE8res - 24 bits"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1280,
    y: 669.775
  }, _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    x: 1280,
    y: 669.775
  }, "40 caract\xE8res - 16 bits"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1280,
    y: 869.775
  }, _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    x: 1280,
    y: 869.775
  }, "80 caract\xE8res - 8 bits"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1280,
    y: 909.775
  }, _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    x: 1280,
    y: 909.775
  }, "80 caract\xE8res - 12 bits"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1280,
    y: 709.775
  }, _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    x: 1280,
    y: 709.775
  }, "40 caract\xE8res - Variable"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1280,
    y: 1069.78
  }, _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    x: 1280,
    y: 1069.78
  }, "Expansion"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1280,
    y: 1129.78
  }, _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    x: 1280,
    y: 1129.78
  }, "Compression"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1280,
    y: 989.775
  }, _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    x: 1280,
    y: 989.775
  }, "Caract\xE8res \xE9tendus"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1280,
    y: 789.775
  }, _tspan27 || (_tspan27 = /*#__PURE__*/React.createElement("tspan", {
    x: 1280,
    y: 789.775
  }, "Octet"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1280,
    y: 1429.78
  }, _tspan28 || (_tspan28 = /*#__PURE__*/React.createElement("tspan", {
    x: 1280,
    y: 1429.78
  }, "Move Buffer"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1280,
    y: 1469.78
  }, _tspan29 || (_tspan29 = /*#__PURE__*/React.createElement("tspan", {
    x: 1280,
    y: 1469.78
  }, "Move Double Buffer"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1280,
    y: 1509.78
  }, _tspan30 || (_tspan30 = /*#__PURE__*/React.createElement("tspan", {
    x: 1280,
    y: 1509.78
  }, "Move Trible Buffer"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1280,
    y: 529.775
  }, _tspan31 || (_tspan31 = /*#__PURE__*/React.createElement("tspan", {
    x: 1280,
    y: 529.775
  }, "Clear Page - 24 Bits"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1280,
    y: 569.775
  }, _tspan32 || (_tspan32 = /*#__PURE__*/React.createElement("tspan", {
    x: 1280,
    y: 569.775
  }, "Clear Page - 16 Bits"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1280,
    y: 1309.78
  }, _tspan33 || (_tspan33 = /*#__PURE__*/React.createElement("tspan", {
    x: 1280,
    y: 1309.78
  }, "Vertical Sync Mask Set"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1280,
    y: 1349.78
  }, _tspan34 || (_tspan34 = /*#__PURE__*/React.createElement("tspan", {
    x: 1280,
    y: 1349.78
  }, "Vertical Sync Mask Reset"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1280,
    y: 1249.78
  }, _tspan35 || (_tspan35 = /*#__PURE__*/React.createElement("tspan", {
    x: 1280,
    y: 1249.78
  }, "Increment Y"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1280,
    y: 1189.78
  }, _tspan36 || (_tspan36 = /*#__PURE__*/React.createElement("tspan", {
    x: 1280,
    y: 1189.78
  }, "No Op\xE9ration"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1920,
    y: 360,
    width: 200,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1920,
    y: 360,
    width: 200,
    height: 40
  })), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2020,
    y: 389.775
  }, _tspan37 || (_tspan37 = /*#__PURE__*/React.createElement("tspan", {
    x: 2020,
    y: 389.775
  }, "COMMANDE"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1940,
    y: 500,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1940,
    y: 500,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1980,
    y: 500,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1980,
    y: 500,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2020,
    y: 500,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2020,
    y: 500,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2060,
    y: 500,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2060,
    y: 500,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1940,
    y: 540,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1940,
    y: 540,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1980,
    y: 540,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1980,
    y: 540,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2020,
    y: 540,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2020,
    y: 540,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2060,
    y: 540,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2060,
    y: 540,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1940,
    y: 600,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1940,
    y: 600,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1980,
    y: 600,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1980,
    y: 600,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2020,
    y: 600,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2020,
    y: 600,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2060,
    y: 600,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2060,
    y: 600,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1940,
    y: 640,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1940,
    y: 640,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1980,
    y: 640,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1980,
    y: 640,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2020,
    y: 640,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2020,
    y: 640,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2060,
    y: 640,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2060,
    y: 640,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1940,
    y: 680,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1940,
    y: 680,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1980,
    y: 680,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1980,
    y: 680,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2020,
    y: 680,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2020,
    y: 680,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2060,
    y: 680,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2060,
    y: 680,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1940,
    y: 840,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1940,
    y: 840,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1980,
    y: 840,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1980,
    y: 840,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2020,
    y: 840,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2020,
    y: 840,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2060,
    y: 840,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2060,
    y: 840,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1940,
    y: 880,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1940,
    y: 880,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1980,
    y: 880,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1980,
    y: 880,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2020,
    y: 880,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2020,
    y: 880,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2060,
    y: 880,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2060,
    y: 880,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1940,
    y: 760,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1940,
    y: 760,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1980,
    y: 760,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1980,
    y: 760,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2020,
    y: 760,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2020,
    y: 760,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2060,
    y: 760,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2060,
    y: 760,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1960,
    y: 489.775
  }, _tspan38 || (_tspan38 = /*#__PURE__*/React.createElement("tspan", {
    x: 1960,
    y: 489.775
  }, "7"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2000,
    y: 489.775
  }, _tspan39 || (_tspan39 = /*#__PURE__*/React.createElement("tspan", {
    x: 2000,
    y: 489.775
  }, "6"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2040,
    y: 489.775
  }, _tspan40 || (_tspan40 = /*#__PURE__*/React.createElement("tspan", {
    x: 2040,
    y: 489.775
  }, "5"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2080,
    y: 489.775
  }, _tspan41 || (_tspan41 = /*#__PURE__*/React.createElement("tspan", {
    x: 2080,
    y: 489.775
  }, "4"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1860,
    y: 489.775
  }, _tspan42 || (_tspan42 = /*#__PURE__*/React.createElement("tspan", {
    x: 1860,
    y: 489.775
  }, "BITS :"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1960,
    y: 629.775
  }, _tspan43 || (_tspan43 = /*#__PURE__*/React.createElement("tspan", {
    x: 1960,
    y: 629.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2000,
    y: 629.775
  }, _tspan44 || (_tspan44 = /*#__PURE__*/React.createElement("tspan", {
    x: 2000,
    y: 629.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2040,
    y: 629.775
  }, _tspan45 || (_tspan45 = /*#__PURE__*/React.createElement("tspan", {
    x: 2040,
    y: 629.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2080,
    y: 629.775
  }, _tspan46 || (_tspan46 = /*#__PURE__*/React.createElement("tspan", {
    x: 2080,
    y: 629.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1960,
    y: 709.775
  }, _tspan47 || (_tspan47 = /*#__PURE__*/React.createElement("tspan", {
    x: 1960,
    y: 709.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2000,
    y: 709.775
  }, _tspan48 || (_tspan48 = /*#__PURE__*/React.createElement("tspan", {
    x: 2000,
    y: 709.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2040,
    y: 709.775
  }, _tspan49 || (_tspan49 = /*#__PURE__*/React.createElement("tspan", {
    x: 2040,
    y: 709.775
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2080,
    y: 709.775
  }, _tspan50 || (_tspan50 = /*#__PURE__*/React.createElement("tspan", {
    x: 2080,
    y: 709.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1960,
    y: 789.775
  }, _tspan51 || (_tspan51 = /*#__PURE__*/React.createElement("tspan", {
    x: 1960,
    y: 789.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2000,
    y: 789.775
  }, _tspan52 || (_tspan52 = /*#__PURE__*/React.createElement("tspan", {
    x: 2000,
    y: 789.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2040,
    y: 789.775
  }, _tspan53 || (_tspan53 = /*#__PURE__*/React.createElement("tspan", {
    x: 2040,
    y: 789.775
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2080,
    y: 789.775
  }, _tspan54 || (_tspan54 = /*#__PURE__*/React.createElement("tspan", {
    x: 2080,
    y: 789.775
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1960,
    y: 869.775
  }, _tspan55 || (_tspan55 = /*#__PURE__*/React.createElement("tspan", {
    x: 1960,
    y: 869.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2000,
    y: 869.775
  }, _tspan56 || (_tspan56 = /*#__PURE__*/React.createElement("tspan", {
    x: 2000,
    y: 869.775
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2040,
    y: 869.775
  }, _tspan57 || (_tspan57 = /*#__PURE__*/React.createElement("tspan", {
    x: 2040,
    y: 869.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2080,
    y: 869.775
  }, _tspan58 || (_tspan58 = /*#__PURE__*/React.createElement("tspan", {
    x: 2080,
    y: 869.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1960,
    y: 909.775
  }, _tspan59 || (_tspan59 = /*#__PURE__*/React.createElement("tspan", {
    x: 1960,
    y: 909.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2000,
    y: 909.775
  }, _tspan60 || (_tspan60 = /*#__PURE__*/React.createElement("tspan", {
    x: 2000,
    y: 909.775
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2040,
    y: 909.775
  }, _tspan61 || (_tspan61 = /*#__PURE__*/React.createElement("tspan", {
    x: 2040,
    y: 909.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2080,
    y: 909.775
  }, _tspan62 || (_tspan62 = /*#__PURE__*/React.createElement("tspan", {
    x: 2080,
    y: 909.775
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1960,
    y: 669.775
  }, _tspan63 || (_tspan63 = /*#__PURE__*/React.createElement("tspan", {
    x: 1960,
    y: 669.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2000,
    y: 669.775
  }, _tspan64 || (_tspan64 = /*#__PURE__*/React.createElement("tspan", {
    x: 2000,
    y: 669.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2040,
    y: 669.775
  }, _tspan65 || (_tspan65 = /*#__PURE__*/React.createElement("tspan", {
    x: 2040,
    y: 669.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2080,
    y: 669.775
  }, _tspan66 || (_tspan66 = /*#__PURE__*/React.createElement("tspan", {
    x: 2080,
    y: 669.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1960,
    y: 529.775
  }, _tspan67 || (_tspan67 = /*#__PURE__*/React.createElement("tspan", {
    x: 1960,
    y: 529.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2000,
    y: 529.775
  }, _tspan68 || (_tspan68 = /*#__PURE__*/React.createElement("tspan", {
    x: 2000,
    y: 529.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2040,
    y: 529.775
  }, _tspan69 || (_tspan69 = /*#__PURE__*/React.createElement("tspan", {
    x: 2040,
    y: 529.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2080,
    y: 529.775
  }, _tspan70 || (_tspan70 = /*#__PURE__*/React.createElement("tspan", {
    x: 2080,
    y: 529.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1960,
    y: 569.775
  }, _tspan71 || (_tspan71 = /*#__PURE__*/React.createElement("tspan", {
    x: 1960,
    y: 569.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2000,
    y: 569.775
  }, _tspan72 || (_tspan72 = /*#__PURE__*/React.createElement("tspan", {
    x: 2000,
    y: 569.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2040,
    y: 569.775
  }, _tspan73 || (_tspan73 = /*#__PURE__*/React.createElement("tspan", {
    x: 2040,
    y: 569.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2080,
    y: 569.775
  }, _tspan74 || (_tspan74 = /*#__PURE__*/React.createElement("tspan", {
    x: 2080,
    y: 569.775
  }, "0"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1940,
    y: 960,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1940,
    y: 960,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1980,
    y: 960,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1980,
    y: 960,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2020,
    y: 960,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2020,
    y: 960,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2060,
    y: 960,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2060,
    y: 960,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1940,
    y: 1040,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1940,
    y: 1040,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1980,
    y: 1040,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1980,
    y: 1040,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2020,
    y: 1040,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2020,
    y: 1040,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2060,
    y: 1040,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2060,
    y: 1040,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1940,
    y: 1100,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1940,
    y: 1100,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1980,
    y: 1100,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1980,
    y: 1100,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2020,
    y: 1100,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2020,
    y: 1100,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2060,
    y: 1100,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2060,
    y: 1100,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1940,
    y: 1280,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1940,
    y: 1280,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1980,
    y: 1280,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1980,
    y: 1280,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2020,
    y: 1280,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2020,
    y: 1280,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2060,
    y: 1280,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2060,
    y: 1280,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1940,
    y: 1320,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1940,
    y: 1320,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1980,
    y: 1320,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1980,
    y: 1320,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2020,
    y: 1320,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2020,
    y: 1320,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2060,
    y: 1320,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2060,
    y: 1320,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1940,
    y: 1160,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1940,
    y: 1160,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1980,
    y: 1160,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1980,
    y: 1160,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2020,
    y: 1160,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2020,
    y: 1160,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2060,
    y: 1160,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2060,
    y: 1160,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1940,
    y: 1220,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1940,
    y: 1220,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1980,
    y: 1220,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1980,
    y: 1220,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2020,
    y: 1220,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2020,
    y: 1220,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2060,
    y: 1220,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2060,
    y: 1220,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1940,
    y: 1400,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1940,
    y: 1400,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1980,
    y: 1400,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1980,
    y: 1400,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2020,
    y: 1400,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2020,
    y: 1400,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2060,
    y: 1400,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2060,
    y: 1400,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1940,
    y: 1440,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1940,
    y: 1440,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1980,
    y: 1440,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1980,
    y: 1440,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2020,
    y: 1440,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2020,
    y: 1440,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2060,
    y: 1440,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2060,
    y: 1440,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1940,
    y: 1480,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1940,
    y: 1480,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1980,
    y: 1480,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1980,
    y: 1480,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2020,
    y: 1480,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2020,
    y: 1480,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2060,
    y: 1480,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2060,
    y: 1480,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1960,
    y: 989.775
  }, _tspan75 || (_tspan75 = /*#__PURE__*/React.createElement("tspan", {
    x: 1960,
    y: 989.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2000,
    y: 989.775
  }, _tspan76 || (_tspan76 = /*#__PURE__*/React.createElement("tspan", {
    x: 2000,
    y: 989.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2040,
    y: 989.775
  }, _tspan77 || (_tspan77 = /*#__PURE__*/React.createElement("tspan", {
    x: 2040,
    y: 989.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2080,
    y: 989.775
  }, _tspan78 || (_tspan78 = /*#__PURE__*/React.createElement("tspan", {
    x: 2080,
    y: 989.775
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1960,
    y: 1069.78
  }, _tspan79 || (_tspan79 = /*#__PURE__*/React.createElement("tspan", {
    x: 1960,
    y: 1069.78
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2000,
    y: 1069.78
  }, _tspan80 || (_tspan80 = /*#__PURE__*/React.createElement("tspan", {
    x: 2000,
    y: 1069.78
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2080,
    y: 1069.78
  }, _tspan81 || (_tspan81 = /*#__PURE__*/React.createElement("tspan", {
    x: 2080,
    y: 1069.78
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2040,
    y: 1069.78
  }, _tspan82 || (_tspan82 = /*#__PURE__*/React.createElement("tspan", {
    x: 2040,
    y: 1069.78
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1960,
    y: 1129.78
  }, _tspan83 || (_tspan83 = /*#__PURE__*/React.createElement("tspan", {
    x: 1960,
    y: 1129.78
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2000,
    y: 1129.78
  }, _tspan84 || (_tspan84 = /*#__PURE__*/React.createElement("tspan", {
    x: 2000,
    y: 1129.78
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2040,
    y: 1129.78
  }, _tspan85 || (_tspan85 = /*#__PURE__*/React.createElement("tspan", {
    x: 2040,
    y: 1129.78
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2080,
    y: 1129.78
  }, _tspan86 || (_tspan86 = /*#__PURE__*/React.createElement("tspan", {
    x: 2080,
    y: 1129.78
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1960,
    y: 1309.78
  }, _tspan87 || (_tspan87 = /*#__PURE__*/React.createElement("tspan", {
    x: 1960,
    y: 1309.78
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2000,
    y: 1309.78
  }, _tspan88 || (_tspan88 = /*#__PURE__*/React.createElement("tspan", {
    x: 2000,
    y: 1309.78
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2040,
    y: 1309.78
  }, _tspan89 || (_tspan89 = /*#__PURE__*/React.createElement("tspan", {
    x: 2040,
    y: 1309.78
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2080,
    y: 1309.78
  }, _tspan90 || (_tspan90 = /*#__PURE__*/React.createElement("tspan", {
    x: 2080,
    y: 1309.78
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1960,
    y: 1349.78
  }, _tspan91 || (_tspan91 = /*#__PURE__*/React.createElement("tspan", {
    x: 1960,
    y: 1349.78
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2000,
    y: 1349.78
  }, _tspan92 || (_tspan92 = /*#__PURE__*/React.createElement("tspan", {
    x: 2000,
    y: 1349.78
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2040,
    y: 1349.78
  }, _tspan93 || (_tspan93 = /*#__PURE__*/React.createElement("tspan", {
    x: 2040,
    y: 1349.78
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2080,
    y: 1349.78
  }, _tspan94 || (_tspan94 = /*#__PURE__*/React.createElement("tspan", {
    x: 2080,
    y: 1349.78
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1960,
    y: 1249.78
  }, _tspan95 || (_tspan95 = /*#__PURE__*/React.createElement("tspan", {
    x: 1960,
    y: 1249.78
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2000,
    y: 1249.78
  }, _tspan96 || (_tspan96 = /*#__PURE__*/React.createElement("tspan", {
    x: 2000,
    y: 1249.78
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2040,
    y: 1249.78
  }, _tspan97 || (_tspan97 = /*#__PURE__*/React.createElement("tspan", {
    x: 2040,
    y: 1249.78
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2080,
    y: 1249.78
  }, _tspan98 || (_tspan98 = /*#__PURE__*/React.createElement("tspan", {
    x: 2080,
    y: 1249.78
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1960,
    y: 1189.78
  }, _tspan99 || (_tspan99 = /*#__PURE__*/React.createElement("tspan", {
    x: 1960,
    y: 1189.78
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2000,
    y: 1189.78
  }, _tspan100 || (_tspan100 = /*#__PURE__*/React.createElement("tspan", {
    x: 2000,
    y: 1189.78
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2040,
    y: 1189.78
  }, _tspan101 || (_tspan101 = /*#__PURE__*/React.createElement("tspan", {
    x: 2040,
    y: 1189.78
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2080,
    y: 1189.78
  }, _tspan102 || (_tspan102 = /*#__PURE__*/React.createElement("tspan", {
    x: 2080,
    y: 1189.78
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1960,
    y: 1429.78
  }, _tspan103 || (_tspan103 = /*#__PURE__*/React.createElement("tspan", {
    x: 1960,
    y: 1429.78
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2040,
    y: 1429.78
  }, _tspan104 || (_tspan104 = /*#__PURE__*/React.createElement("tspan", {
    x: 2040,
    y: 1429.78
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2000,
    y: 1429.78
  }, _tspan105 || (_tspan105 = /*#__PURE__*/React.createElement("tspan", {
    x: 2000,
    y: 1429.78
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2080,
    y: 1429.78
  }, _tspan106 || (_tspan106 = /*#__PURE__*/React.createElement("tspan", {
    x: 2080,
    y: 1429.78
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1960,
    y: 1469.78
  }, _tspan107 || (_tspan107 = /*#__PURE__*/React.createElement("tspan", {
    x: 1960,
    y: 1469.78
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2080,
    y: 1469.78
  }, _tspan108 || (_tspan108 = /*#__PURE__*/React.createElement("tspan", {
    x: 2080,
    y: 1469.78
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2000,
    y: 1469.78
  }, _tspan109 || (_tspan109 = /*#__PURE__*/React.createElement("tspan", {
    x: 2000,
    y: 1469.78
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2040,
    y: 1469.78
  }, _tspan110 || (_tspan110 = /*#__PURE__*/React.createElement("tspan", {
    x: 2040,
    y: 1469.78
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1960,
    y: 1509.78
  }, _tspan111 || (_tspan111 = /*#__PURE__*/React.createElement("tspan", {
    x: 1960,
    y: 1509.78
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2000,
    y: 1509.78
  }, _tspan112 || (_tspan112 = /*#__PURE__*/React.createElement("tspan", {
    x: 2000,
    y: 1509.78
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2040,
    y: 1509.78
  }, _tspan113 || (_tspan113 = /*#__PURE__*/React.createElement("tspan", {
    x: 2040,
    y: 1509.78
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2080,
    y: 1509.78
  }, _tspan114 || (_tspan114 = /*#__PURE__*/React.createElement("tspan", {
    x: 2080,
    y: 1509.78
  }, "1"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "2010,400 2010,420 2000,420 2020,440 2040,420 2030,420 2030,400 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "2010,400 2010,420 2000,420 2020,440 2040,420 2030,420 2030,400 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "2010,400 2010,420 2000,420 2020,440 2040,420 2030,420 2030,400 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1880,
    y1: 520,
    x2: 1908,
    y2: 520
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1860,
    y1: 520,
    x2: 1864,
    y2: 520
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1866.67,
    y1: 520,
    x2: 1870.67,
    y2: 520
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1873.33,
    y1: 520,
    x2: 1877.33,
    y2: 520
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1908,525 1918,520 1908,515 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1908,525 1918,520 1908,515 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1880,
    y1: 560,
    x2: 1908,
    y2: 560
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1860,
    y1: 560,
    x2: 1864,
    y2: 560
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1866.67,
    y1: 560,
    x2: 1870.67,
    y2: 560
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1873.33,
    y1: 560,
    x2: 1877.33,
    y2: 560
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1908,565 1918,560 1908,555 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1908,565 1918,560 1908,555 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1880,
    y1: 620,
    x2: 1908,
    y2: 620
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1860,
    y1: 620,
    x2: 1864,
    y2: 620
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1866.67,
    y1: 620,
    x2: 1870.67,
    y2: 620
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1873.33,
    y1: 620,
    x2: 1877.33,
    y2: 620
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1908,625 1918,620 1908,615 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1908,625 1918,620 1908,615 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1880,
    y1: 660,
    x2: 1908,
    y2: 660
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1860,
    y1: 660,
    x2: 1864,
    y2: 660
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1866.67,
    y1: 660,
    x2: 1870.67,
    y2: 660
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1873.33,
    y1: 660,
    x2: 1877.33,
    y2: 660
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1908,665 1918,660 1908,655 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1908,665 1918,660 1908,655 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1880,
    y1: 700,
    x2: 1908,
    y2: 700
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1860,
    y1: 700,
    x2: 1864,
    y2: 700
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1866.67,
    y1: 700,
    x2: 1870.67,
    y2: 700
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1873.33,
    y1: 700,
    x2: 1877.33,
    y2: 700
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1908,705 1918,700 1908,695 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1908,705 1918,700 1908,695 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1880,
    y1: 860,
    x2: 1908,
    y2: 860
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1860,
    y1: 860,
    x2: 1864,
    y2: 860
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1866.67,
    y1: 860,
    x2: 1870.67,
    y2: 860
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1873.33,
    y1: 860,
    x2: 1877.33,
    y2: 860
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1908,865 1918,860 1908,855 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1908,865 1918,860 1908,855 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1880,
    y1: 900,
    x2: 1908,
    y2: 900
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1860,
    y1: 900,
    x2: 1864,
    y2: 900
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1866.67,
    y1: 900,
    x2: 1870.67,
    y2: 900
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1873.33,
    y1: 900,
    x2: 1877.33,
    y2: 900
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1908,905 1918,900 1908,895 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1908,905 1918,900 1908,895 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1880,
    y1: 780,
    x2: 1908,
    y2: 780
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1860,
    y1: 780,
    x2: 1864,
    y2: 780
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1866.67,
    y1: 780,
    x2: 1870.67,
    y2: 780
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1873.33,
    y1: 780,
    x2: 1877.33,
    y2: 780
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1908,785 1918,780 1908,775 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1908,785 1918,780 1908,775 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1880,
    y1: 1240,
    x2: 1908,
    y2: 1240
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1860,
    y1: 1240,
    x2: 1864,
    y2: 1240
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1866.67,
    y1: 1240,
    x2: 1870.67,
    y2: 1240
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1873.33,
    y1: 1240,
    x2: 1877.33,
    y2: 1240
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1908,1245 1918,1240 1908,1235 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1908,1245 1918,1240 1908,1235 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1880,
    y1: 980,
    x2: 1908,
    y2: 980
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1860,
    y1: 980,
    x2: 1864,
    y2: 980
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1866.67,
    y1: 980,
    x2: 1870.67,
    y2: 980
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1873.33,
    y1: 980,
    x2: 1877.33,
    y2: 980
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1908,985 1918,980 1908,975 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1908,985 1918,980 1908,975 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1880,
    y1: 1060,
    x2: 1908,
    y2: 1060
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1860,
    y1: 1060,
    x2: 1864,
    y2: 1060
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1866.67,
    y1: 1060,
    x2: 1870.67,
    y2: 1060
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1873.33,
    y1: 1060,
    x2: 1877.33,
    y2: 1060
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1908,1065 1918,1060 1908,1055 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1908,1065 1918,1060 1908,1055 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1880,
    y1: 1120,
    x2: 1908,
    y2: 1120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1860,
    y1: 1120,
    x2: 1864,
    y2: 1120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1866.67,
    y1: 1120,
    x2: 1870.67,
    y2: 1120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1873.33,
    y1: 1120,
    x2: 1877.33,
    y2: 1120
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1908,1125 1918,1120 1908,1115 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1908,1125 1918,1120 1908,1115 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1880,
    y1: 1300,
    x2: 1908,
    y2: 1300
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1860,
    y1: 1300,
    x2: 1864,
    y2: 1300
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1866.67,
    y1: 1300,
    x2: 1870.67,
    y2: 1300
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1873.33,
    y1: 1300,
    x2: 1877.33,
    y2: 1300
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1908,1305 1918,1300 1908,1295 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1908,1305 1918,1300 1908,1295 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1880,
    y1: 1340,
    x2: 1908,
    y2: 1340
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1860,
    y1: 1340,
    x2: 1864,
    y2: 1340
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1866.67,
    y1: 1340,
    x2: 1870.67,
    y2: 1340
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1873.33,
    y1: 1340,
    x2: 1877.33,
    y2: 1340
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1908,1345 1918,1340 1908,1335 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1908,1345 1918,1340 1908,1335 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1880,
    y1: 1420,
    x2: 1908,
    y2: 1420
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1860,
    y1: 1420,
    x2: 1864,
    y2: 1420
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1866.67,
    y1: 1420,
    x2: 1870.67,
    y2: 1420
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1873.33,
    y1: 1420,
    x2: 1877.33,
    y2: 1420
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1908,1425 1918,1420 1908,1415 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1908,1425 1918,1420 1908,1415 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1880,
    y1: 1460,
    x2: 1908,
    y2: 1460
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1860,
    y1: 1460,
    x2: 1864,
    y2: 1460
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1866.67,
    y1: 1460,
    x2: 1870.67,
    y2: 1460
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1873.33,
    y1: 1460,
    x2: 1877.33,
    y2: 1460
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1908,1465 1918,1460 1908,1455 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1908,1465 1918,1460 1908,1455 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1880,
    y1: 1500,
    x2: 1908,
    y2: 1500
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1860,
    y1: 1500,
    x2: 1864,
    y2: 1500
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1866.67,
    y1: 1500,
    x2: 1870.67,
    y2: 1500
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1873.33,
    y1: 1500,
    x2: 1877.33,
    y2: 1500
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1908,1505 1918,1500 1908,1495 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1908,1505 1918,1500 1908,1495 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1880,
    y1: 1180,
    x2: 1908,
    y2: 1180
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1860,
    y1: 1180,
    x2: 1864,
    y2: 1180
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1866.67,
    y1: 1180,
    x2: 1870.67,
    y2: 1180
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1873.33,
    y1: 1180,
    x2: 1877.33,
    y2: 1180
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1908,1185 1918,1180 1908,1175 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1908,1185 1918,1180 1908,1175 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1700,
    y1: 520,
    x2: 1728,
    y2: 520
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1680,
    y1: 520,
    x2: 1684,
    y2: 520
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1686.67,
    y1: 520,
    x2: 1690.67,
    y2: 520
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1693.33,
    y1: 520,
    x2: 1697.33,
    y2: 520
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1728,525 1738,520 1728,515 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1728,525 1738,520 1728,515 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1700,
    y1: 560,
    x2: 1728,
    y2: 560
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1680,
    y1: 560,
    x2: 1684,
    y2: 560
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1686.67,
    y1: 560,
    x2: 1690.67,
    y2: 560
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1693.33,
    y1: 560,
    x2: 1697.33,
    y2: 560
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1728,565 1738,560 1728,555 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1728,565 1738,560 1728,555 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1700,
    y1: 620,
    x2: 1728,
    y2: 620
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1680,
    y1: 620,
    x2: 1684,
    y2: 620
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1686.67,
    y1: 620,
    x2: 1690.67,
    y2: 620
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1693.33,
    y1: 620,
    x2: 1697.33,
    y2: 620
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1728,625 1738,620 1728,615 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1728,625 1738,620 1728,615 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1700,
    y1: 660,
    x2: 1728,
    y2: 660
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1680,
    y1: 660,
    x2: 1684,
    y2: 660
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1686.67,
    y1: 660,
    x2: 1690.67,
    y2: 660
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1693.33,
    y1: 660,
    x2: 1697.33,
    y2: 660
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1728,665 1738,660 1728,655 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1728,665 1738,660 1728,655 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1700,
    y1: 700,
    x2: 1728,
    y2: 700
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1680,
    y1: 700,
    x2: 1684,
    y2: 700
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1686.67,
    y1: 700,
    x2: 1690.67,
    y2: 700
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1693.33,
    y1: 700,
    x2: 1697.33,
    y2: 700
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1728,705 1738,700 1728,695 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1728,705 1738,700 1728,695 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1700,
    y1: 860,
    x2: 1728,
    y2: 860
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1680,
    y1: 860,
    x2: 1684,
    y2: 860
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1686.67,
    y1: 860,
    x2: 1690.67,
    y2: 860
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1693.33,
    y1: 860,
    x2: 1697.33,
    y2: 860
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1728,865 1738,860 1728,855 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1728,865 1738,860 1728,855 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1700,
    y1: 900,
    x2: 1728,
    y2: 900
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1680,
    y1: 900,
    x2: 1684,
    y2: 900
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1686.67,
    y1: 900,
    x2: 1690.67,
    y2: 900
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1693.33,
    y1: 900,
    x2: 1697.33,
    y2: 900
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1728,905 1738,900 1728,895 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1728,905 1738,900 1728,895 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1700,
    y1: 780,
    x2: 1728,
    y2: 780
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1680,
    y1: 780,
    x2: 1684,
    y2: 780
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1686.67,
    y1: 780,
    x2: 1690.67,
    y2: 780
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1693.33,
    y1: 780,
    x2: 1697.33,
    y2: 780
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1728,785 1738,780 1728,775 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1728,785 1738,780 1728,775 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1700,
    y1: 1240,
    x2: 1728,
    y2: 1240
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1680,
    y1: 1240,
    x2: 1684,
    y2: 1240
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1686.67,
    y1: 1240,
    x2: 1690.67,
    y2: 1240
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1693.33,
    y1: 1240,
    x2: 1697.33,
    y2: 1240
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1728,1245 1738,1240 1728,1235 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1728,1245 1738,1240 1728,1235 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1700,
    y1: 980,
    x2: 1728,
    y2: 980
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1680,
    y1: 980,
    x2: 1684,
    y2: 980
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1686.67,
    y1: 980,
    x2: 1690.67,
    y2: 980
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1693.33,
    y1: 980,
    x2: 1697.33,
    y2: 980
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1728,985 1738,980 1728,975 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1728,985 1738,980 1728,975 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1700,
    y1: 1060,
    x2: 1728,
    y2: 1060
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1680,
    y1: 1060,
    x2: 1684,
    y2: 1060
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1686.67,
    y1: 1060,
    x2: 1690.67,
    y2: 1060
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1693.33,
    y1: 1060,
    x2: 1697.33,
    y2: 1060
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1728,1065 1738,1060 1728,1055 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1728,1065 1738,1060 1728,1055 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1700,
    y1: 1120,
    x2: 1728,
    y2: 1120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1680,
    y1: 1120,
    x2: 1684,
    y2: 1120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1686.67,
    y1: 1120,
    x2: 1690.67,
    y2: 1120
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1693.33,
    y1: 1120,
    x2: 1697.33,
    y2: 1120
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1728,1125 1738,1120 1728,1115 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1728,1125 1738,1120 1728,1115 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1700,
    y1: 1300,
    x2: 1728,
    y2: 1300
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1680,
    y1: 1300,
    x2: 1684,
    y2: 1300
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1686.67,
    y1: 1300,
    x2: 1690.67,
    y2: 1300
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1693.33,
    y1: 1300,
    x2: 1697.33,
    y2: 1300
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1728,1305 1738,1300 1728,1295 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1728,1305 1738,1300 1728,1295 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1700,
    y1: 1340,
    x2: 1728,
    y2: 1340
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1680,
    y1: 1340,
    x2: 1684,
    y2: 1340
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1686.67,
    y1: 1340,
    x2: 1690.67,
    y2: 1340
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1693.33,
    y1: 1340,
    x2: 1697.33,
    y2: 1340
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1728,1345 1738,1340 1728,1335 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1728,1345 1738,1340 1728,1335 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1700,
    y1: 1420,
    x2: 1728,
    y2: 1420
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1680,
    y1: 1420,
    x2: 1684,
    y2: 1420
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1686.67,
    y1: 1420,
    x2: 1690.67,
    y2: 1420
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1693.33,
    y1: 1420,
    x2: 1697.33,
    y2: 1420
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1728,1425 1738,1420 1728,1415 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1728,1425 1738,1420 1728,1415 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1700,
    y1: 1460,
    x2: 1728,
    y2: 1460
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1680,
    y1: 1460,
    x2: 1684,
    y2: 1460
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1686.67,
    y1: 1460,
    x2: 1690.67,
    y2: 1460
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1693.33,
    y1: 1460,
    x2: 1697.33,
    y2: 1460
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1728,1465 1738,1460 1728,1455 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1728,1465 1738,1460 1728,1455 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1700,
    y1: 1500,
    x2: 1728,
    y2: 1500
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1680,
    y1: 1500,
    x2: 1684,
    y2: 1500
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1686.67,
    y1: 1500,
    x2: 1690.67,
    y2: 1500
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1693.33,
    y1: 1500,
    x2: 1697.33,
    y2: 1500
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1728,1505 1738,1500 1728,1495 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1728,1505 1738,1500 1728,1495 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1700,
    y1: 1180,
    x2: 1728,
    y2: 1180
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1680,
    y1: 1180,
    x2: 1684,
    y2: 1180
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1686.67,
    y1: 1180,
    x2: 1690.67,
    y2: 1180
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1693.33,
    y1: 1180,
    x2: 1697.33,
    y2: 1180
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1728,1185 1738,1180 1728,1175 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1728,1185 1738,1180 1728,1175 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1760,
    y: 360,
    width: 80,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1760,
    y: 360,
    width: 80,
    height: 40
  })), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1800,
    y: 389.775
  }, _tspan115 || (_tspan115 = /*#__PURE__*/React.createElement("tspan", {
    x: 1800,
    y: 389.775
  }, "NOM"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1790,400 1790,420 1780,420 1800,440 1820,420 1810,420 1810,400 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1790,400 1790,420 1780,420 1800,440 1820,420 1810,420 1810,400 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1790,400 1790,420 1780,420 1800,440 1820,420 1810,420 1810,400 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1340,
    y: 360,
    width: 240,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1340,
    y: 360,
    width: 240,
    height: 40
  })), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1460,
    y: 389.775
  }, _tspan116 || (_tspan116 = /*#__PURE__*/React.createElement("tspan", {
    x: 1460,
    y: 389.775
  }, "Type"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1450,400 1450,420 1440,420 1460,440 1480,420 1470,420 1470,400 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1450,400 1450,420 1440,420 1460,440 1480,420 1470,420 1470,400 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1450,400 1450,420 1440,420 1460,440 1480,420 1470,420 1470,400 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2120,
    y: 360,
    width: 200,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2120,
    y: 360,
    width: 200,
    height: 40
  })), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2220,
    y: 389.775
  }, _tspan117 || (_tspan117 = /*#__PURE__*/React.createElement("tspan", {
    x: 2220,
    y: 389.775
  }, "PARAMETRE"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "2210,400 2210,420 2200,420 2220,440 2240,420 2230,420 2230,400 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "2210,400 2210,420 2200,420 2220,440 2240,420 2230,420 2230,400 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "2210,400 2210,420 2200,420 2220,440 2240,420 2230,420 2230,400 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2140,
    y: 1280,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2140,
    y: 1280,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2180,
    y: 1280,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2180,
    y: 1280,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2220,
    y: 1280,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2220,
    y: 1280,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2260,
    y: 1280,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2260,
    y: 1280,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2140,
    y: 1320,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2140,
    y: 1320,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2180,
    y: 1320,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2180,
    y: 1320,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2220,
    y: 1320,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2220,
    y: 1320,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2260,
    y: 1320,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2260,
    y: 1320,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2140,
    y: 960,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2140,
    y: 960,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2180,
    y: 960,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2180,
    y: 960,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2220,
    y: 960,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2220,
    y: 960,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2260,
    y: 960,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2260,
    y: 960,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2140,
    y: 1040,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2140,
    y: 1040,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2180,
    y: 1040,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2180,
    y: 1040,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2220,
    y: 1040,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2220,
    y: 1040,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2260,
    y: 1040,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2260,
    y: 1040,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2140,
    y: 1100,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2140,
    y: 1100,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2180,
    y: 1100,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2180,
    y: 1100,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2220,
    y: 1100,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2220,
    y: 1100,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2260,
    y: 1100,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2260,
    y: 1100,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2140,
    y: 1160,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2140,
    y: 1160,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2180,
    y: 1160,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2180,
    y: 1160,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2220,
    y: 1160,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2220,
    y: 1160,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2260,
    y: 1160,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2260,
    y: 1160,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2140,
    y: 500,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2140,
    y: 500,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2180,
    y: 500,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2180,
    y: 500,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2220,
    y: 500,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2220,
    y: 500,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2260,
    y: 500,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2260,
    y: 500,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2140,
    y: 540,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2140,
    y: 540,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2180,
    y: 540,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2180,
    y: 540,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2220,
    y: 540,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2220,
    y: 540,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2260,
    y: 540,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2260,
    y: 540,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2140,
    y: 600,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2140,
    y: 600,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2180,
    y: 600,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2180,
    y: 600,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2220,
    y: 600,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2220,
    y: 600,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2260,
    y: 600,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2260,
    y: 600,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2140,
    y: 640,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2140,
    y: 640,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2180,
    y: 640,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2180,
    y: 640,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2220,
    y: 640,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2220,
    y: 640,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2260,
    y: 640,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2260,
    y: 640,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2140,
    y: 680,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2140,
    y: 680,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2180,
    y: 680,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2180,
    y: 680,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2220,
    y: 680,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2220,
    y: 680,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2260,
    y: 680,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2260,
    y: 680,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2140,
    y: 1400,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2140,
    y: 1400,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2180,
    y: 1400,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2180,
    y: 1400,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2220,
    y: 1400,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2220,
    y: 1400,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2260,
    y: 1400,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2260,
    y: 1400,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2140,
    y: 1440,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2140,
    y: 1440,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2180,
    y: 1440,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2180,
    y: 1440,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2220,
    y: 1440,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2220,
    y: 1440,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2260,
    y: 1440,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2260,
    y: 1440,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2140,
    y: 1480,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2140,
    y: 1480,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2180,
    y: 1480,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2180,
    y: 1480,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2220,
    y: 1480,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2220,
    y: 1480,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2260,
    y: 1480,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2260,
    y: 1480,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2140,
    y: 840,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2140,
    y: 840,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2180,
    y: 840,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2180,
    y: 840,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2220,
    y: 840,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2220,
    y: 840,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2260,
    y: 840,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2260,
    y: 840,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2140,
    y: 880,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2140,
    y: 880,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2180,
    y: 880,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2180,
    y: 880,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2220,
    y: 880,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2220,
    y: 880,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2260,
    y: 880,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2260,
    y: 880,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2140,
    y: 760,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2140,
    y: 760,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2180,
    y: 760,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2180,
    y: 760,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2220,
    y: 760,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2220,
    y: 760,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2260,
    y: 760,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2260,
    y: 760,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2140,
    y: 1220,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2140,
    y: 1220,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2180,
    y: 1220,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2180,
    y: 1220,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2220,
    y: 1220,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2220,
    y: 1220,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2260,
    y: 1220,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2260,
    y: 1220,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2160,
    y: 489.775
  }, _tspan118 || (_tspan118 = /*#__PURE__*/React.createElement("tspan", {
    x: 2160,
    y: 489.775
  }, "3"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2200,
    y: 489.775
  }, _tspan119 || (_tspan119 = /*#__PURE__*/React.createElement("tspan", {
    x: 2200,
    y: 489.775
  }, "2"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2240,
    y: 489.775
  }, _tspan120 || (_tspan120 = /*#__PURE__*/React.createElement("tspan", {
    x: 2240,
    y: 489.775
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2280,
    y: 489.775
  }, _tspan121 || (_tspan121 = /*#__PURE__*/React.createElement("tspan", {
    x: 2280,
    y: 489.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2160,
    y: 529.364
  }, _tspan122 || (_tspan122 = /*#__PURE__*/React.createElement("tspan", {
    x: 2160,
    y: 529.364
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2240,
    y: 529.364
  }, _tspan123 || (_tspan123 = /*#__PURE__*/React.createElement("tspan", {
    x: 2240,
    y: 529.364
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2200,
    y: 529.364
  }, _tspan124 || (_tspan124 = /*#__PURE__*/React.createElement("tspan", {
    x: 2200,
    y: 529.364
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2280,
    y: 529.364
  }, _tspan125 || (_tspan125 = /*#__PURE__*/React.createElement("tspan", {
    x: 2280,
    y: 529.364
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2160,
    y: 569.775
  }, _tspan126 || (_tspan126 = /*#__PURE__*/React.createElement("tspan", {
    x: 2160,
    y: 569.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2200,
    y: 569.775
  }, _tspan127 || (_tspan127 = /*#__PURE__*/React.createElement("tspan", {
    x: 2200,
    y: 569.775
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2240,
    y: 569.775
  }, _tspan128 || (_tspan128 = /*#__PURE__*/React.createElement("tspan", {
    x: 2240,
    y: 569.775
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2280,
    y: 569.775
  }, _tspan129 || (_tspan129 = /*#__PURE__*/React.createElement("tspan", {
    x: 2280,
    y: 569.775
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 18.0622,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2160,
    y: 625.987
  }, _tspan130 || (_tspan130 = /*#__PURE__*/React.createElement("tspan", {
    x: 2160,
    y: 625.987
  }, "R/W"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2280,
    y: 629.364
  }, _tspan131 || (_tspan131 = /*#__PURE__*/React.createElement("tspan", {
    x: 2280,
    y: 629.364
  }, "i"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2200,
    y: 629.775
  }, _tspan132 || (_tspan132 = /*#__PURE__*/React.createElement("tspan", {
    x: 2200,
    y: 629.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2240,
    y: 629.775
  }, _tspan133 || (_tspan133 = /*#__PURE__*/React.createElement("tspan", {
    x: 2240,
    y: 629.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 18.0622,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2160,
    y: 665.987
  }, _tspan134 || (_tspan134 = /*#__PURE__*/React.createElement("tspan", {
    x: 2160,
    y: 665.987
  }, "R/W"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2280,
    y: 669.364
  }, _tspan135 || (_tspan135 = /*#__PURE__*/React.createElement("tspan", {
    x: 2280,
    y: 669.364
  }, "i"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2200,
    y: 669.775
  }, _tspan136 || (_tspan136 = /*#__PURE__*/React.createElement("tspan", {
    x: 2200,
    y: 669.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2240,
    y: 669.775
  }, _tspan137 || (_tspan137 = /*#__PURE__*/React.createElement("tspan", {
    x: 2240,
    y: 669.775
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 18.0622,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2160,
    y: 705.987
  }, _tspan138 || (_tspan138 = /*#__PURE__*/React.createElement("tspan", {
    x: 2160,
    y: 705.987
  }, "R/W"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2200,
    y: 709.775
  }, _tspan139 || (_tspan139 = /*#__PURE__*/React.createElement("tspan", {
    x: 2200,
    y: 709.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2240,
    y: 709.775
  }, _tspan140 || (_tspan140 = /*#__PURE__*/React.createElement("tspan", {
    x: 2240,
    y: 709.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2280,
    y: 709.364
  }, _tspan141 || (_tspan141 = /*#__PURE__*/React.createElement("tspan", {
    x: 2280,
    y: 709.364
  }, "i"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 18.0622,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2160,
    y: 785.987
  }, _tspan142 || (_tspan142 = /*#__PURE__*/React.createElement("tspan", {
    x: 2160,
    y: 785.987
  }, "R/W"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2200,
    y: 789.364
  }, _tspan143 || (_tspan143 = /*#__PURE__*/React.createElement("tspan", {
    x: 2200,
    y: 789.364
  }, "p"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2240,
    y: 789.364
  }, _tspan144 || (_tspan144 = /*#__PURE__*/React.createElement("tspan", {
    x: 2240,
    y: 789.364
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2280,
    y: 789.364
  }, _tspan145 || (_tspan145 = /*#__PURE__*/React.createElement("tspan", {
    x: 2280,
    y: 789.364
  }, "i"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 18.0622,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2160,
    y: 866.25
  }, _tspan146 || (_tspan146 = /*#__PURE__*/React.createElement("tspan", {
    x: 2160,
    y: 866.25
  }, "R/W"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2200,
    y: 869.775
  }, _tspan147 || (_tspan147 = /*#__PURE__*/React.createElement("tspan", {
    x: 2200,
    y: 869.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2240,
    y: 869.775
  }, _tspan148 || (_tspan148 = /*#__PURE__*/React.createElement("tspan", {
    x: 2240,
    y: 869.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2280,
    y: 869.775
  }, _tspan149 || (_tspan149 = /*#__PURE__*/React.createElement("tspan", {
    x: 2280,
    y: 869.775
  }, "i"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 18.0622,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2160,
    y: 906.25
  }, _tspan150 || (_tspan150 = /*#__PURE__*/React.createElement("tspan", {
    x: 2160,
    y: 906.25
  }, "R/W"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2200,
    y: 909.775
  }, _tspan151 || (_tspan151 = /*#__PURE__*/React.createElement("tspan", {
    x: 2200,
    y: 909.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2240,
    y: 909.775
  }, _tspan152 || (_tspan152 = /*#__PURE__*/React.createElement("tspan", {
    x: 2240,
    y: 909.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2280,
    y: 909.775
  }, _tspan153 || (_tspan153 = /*#__PURE__*/React.createElement("tspan", {
    x: 2280,
    y: 909.775
  }, "i"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 18.0622,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2160,
    y: 985.987
  }, _tspan154 || (_tspan154 = /*#__PURE__*/React.createElement("tspan", {
    x: 2160,
    y: 985.987
  }, "R/W"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2200,
    y: 989.775
  }, _tspan155 || (_tspan155 = /*#__PURE__*/React.createElement("tspan", {
    x: 2200,
    y: 989.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2240,
    y: 989.775
  }, _tspan156 || (_tspan156 = /*#__PURE__*/React.createElement("tspan", {
    x: 2240,
    y: 989.775
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2280,
    y: 989.775
  }, _tspan157 || (_tspan157 = /*#__PURE__*/React.createElement("tspan", {
    x: 2280,
    y: 989.775
  }, "i"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2160,
    y: 1069.36
  }, _tspan158 || (_tspan158 = /*#__PURE__*/React.createElement("tspan", {
    x: 2160,
    y: 1069.36
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2200,
    y: 1069.78
  }, _tspan159 || (_tspan159 = /*#__PURE__*/React.createElement("tspan", {
    x: 2200,
    y: 1069.78
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2240,
    y: 1069.78
  }, _tspan160 || (_tspan160 = /*#__PURE__*/React.createElement("tspan", {
    x: 2240,
    y: 1069.78
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2280,
    y: 1069.78
  }, _tspan161 || (_tspan161 = /*#__PURE__*/React.createElement("tspan", {
    x: 2280,
    y: 1069.78
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2160,
    y: 1129.78
  }, _tspan162 || (_tspan162 = /*#__PURE__*/React.createElement("tspan", {
    x: 2160,
    y: 1129.78
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2200,
    y: 1129.78
  }, _tspan163 || (_tspan163 = /*#__PURE__*/React.createElement("tspan", {
    x: 2200,
    y: 1129.78
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2240,
    y: 1129.78
  }, _tspan164 || (_tspan164 = /*#__PURE__*/React.createElement("tspan", {
    x: 2240,
    y: 1129.78
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2280,
    y: 1129.78
  }, _tspan165 || (_tspan165 = /*#__PURE__*/React.createElement("tspan", {
    x: 2280,
    y: 1129.78
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2160,
    y: 1189.36
  }, _tspan166 || (_tspan166 = /*#__PURE__*/React.createElement("tspan", {
    x: 2160,
    y: 1189.36
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2200,
    y: 1189.78
  }, _tspan167 || (_tspan167 = /*#__PURE__*/React.createElement("tspan", {
    x: 2200,
    y: 1189.78
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2240,
    y: 1189.78
  }, _tspan168 || (_tspan168 = /*#__PURE__*/React.createElement("tspan", {
    x: 2240,
    y: 1189.78
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2280,
    y: 1189.36
  }, _tspan169 || (_tspan169 = /*#__PURE__*/React.createElement("tspan", {
    x: 2280,
    y: 1189.36
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2160,
    y: 1249.36
  }, _tspan170 || (_tspan170 = /*#__PURE__*/React.createElement("tspan", {
    x: 2160,
    y: 1249.36
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2200,
    y: 1249.78
  }, _tspan171 || (_tspan171 = /*#__PURE__*/React.createElement("tspan", {
    x: 2200,
    y: 1249.78
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2240,
    y: 1249.78
  }, _tspan172 || (_tspan172 = /*#__PURE__*/React.createElement("tspan", {
    x: 2240,
    y: 1249.78
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2280,
    y: 1249.78
  }, _tspan173 || (_tspan173 = /*#__PURE__*/React.createElement("tspan", {
    x: 2280,
    y: 1249.78
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2160,
    y: 1309.36
  }, _tspan174 || (_tspan174 = /*#__PURE__*/React.createElement("tspan", {
    x: 2160,
    y: 1309.36
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2200,
    y: 1309.36
  }, _tspan175 || (_tspan175 = /*#__PURE__*/React.createElement("tspan", {
    x: 2200,
    y: 1309.36
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2240,
    y: 1309.78
  }, _tspan176 || (_tspan176 = /*#__PURE__*/React.createElement("tspan", {
    x: 2240,
    y: 1309.78
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2280,
    y: 1309.36
  }, _tspan177 || (_tspan177 = /*#__PURE__*/React.createElement("tspan", {
    x: 2280,
    y: 1309.36
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2200,
    y: 1349.78
  }, _tspan178 || (_tspan178 = /*#__PURE__*/React.createElement("tspan", {
    x: 2200,
    y: 1349.78
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2160,
    y: 1349.78
  }, _tspan179 || (_tspan179 = /*#__PURE__*/React.createElement("tspan", {
    x: 2160,
    y: 1349.78
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2240,
    y: 1349.78
  }, _tspan180 || (_tspan180 = /*#__PURE__*/React.createElement("tspan", {
    x: 2240,
    y: 1349.78
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2280,
    y: 1349.78
  }, _tspan181 || (_tspan181 = /*#__PURE__*/React.createElement("tspan", {
    x: 2280,
    y: 1349.78
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2160,
    y: 1509.78
  }, _tspan182 || (_tspan182 = /*#__PURE__*/React.createElement("tspan", {
    x: 2160,
    y: 1509.78
  }, "s"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2200,
    y: 1509.78
  }, _tspan183 || (_tspan183 = /*#__PURE__*/React.createElement("tspan", {
    x: 2200,
    y: 1509.78
  }, "s2"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2240,
    y: 1509.78
  }, _tspan184 || (_tspan184 = /*#__PURE__*/React.createElement("tspan", {
    x: 2240,
    y: 1509.78
  }, "a"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2280,
    y: 1509.78
  }, _tspan185 || (_tspan185 = /*#__PURE__*/React.createElement("tspan", {
    x: 2280,
    y: 1509.78
  }, "a2"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2160,
    y: 1429.36
  }, _tspan186 || (_tspan186 = /*#__PURE__*/React.createElement("tspan", {
    x: 2160,
    y: 1429.36
  }, "s"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2200,
    y: 1429.78
  }, _tspan187 || (_tspan187 = /*#__PURE__*/React.createElement("tspan", {
    x: 2200,
    y: 1429.78
  }, "s2"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2240,
    y: 1429.78
  }, _tspan188 || (_tspan188 = /*#__PURE__*/React.createElement("tspan", {
    x: 2240,
    y: 1429.78
  }, "a"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2280,
    y: 1429.78
  }, _tspan189 || (_tspan189 = /*#__PURE__*/React.createElement("tspan", {
    x: 2280,
    y: 1429.78
  }, "a2"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2160,
    y: 1469.36
  }, _tspan190 || (_tspan190 = /*#__PURE__*/React.createElement("tspan", {
    x: 2160,
    y: 1469.36
  }, "s"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2200,
    y: 1469.78
  }, _tspan191 || (_tspan191 = /*#__PURE__*/React.createElement("tspan", {
    x: 2200,
    y: 1469.78
  }, "s2"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2240,
    y: 1469.78
  }, _tspan192 || (_tspan192 = /*#__PURE__*/React.createElement("tspan", {
    x: 2240,
    y: 1469.78
  }, "a"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2280,
    y: 1469.78
  }, _tspan193 || (_tspan193 = /*#__PURE__*/React.createElement("tspan", {
    x: 2280,
    y: 1469.78
  }, "a2"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommandesDirect);
export default __webpack_public_path__ + "static/media/CommandesDirect.23232a2b5fc94ef396b8ea28bcaf34c0.svg";
export { ForwardRef as ReactComponent };